module.exports = __webpack_public_path__ + "static/goodrx-mobile-81067412dbf1f30eb1c0c7c3f2f75b76.png";